import React from 'react';
import SelectBox from './../../../../components/SelectBox';
import counties from './services/flcounties.json';

let countiesList = [].concat(counties.data)
                .sort((a,b) => (a.NAME > b.NAME) ? 1 : ((b.NAME > a.NAME) ? -1 : 0))
                .map((item, key) => {
                    return({id: item.COUNTYFP, name: item.COUNTYFP + ' - ' + item.NAME})
                });

class SelectCounty extends React.Component{

  constructor(props) {
    super(props);
    this.select = this.select.bind(this);
    this.SelectBox = React.createRef();
  };

  updateCountyOnList(countyFp){
    this.SelectBox.current.updateSelectedItem(countyFp);
  }

  select(countyFp){
    this.props.selectValue(countyFp,'list');
  }

  render() {
    return (
      <div>
        <SelectBox handler={this.select} inputName={"Counties"} list={countiesList} ref={this.SelectBox}/>
      </div>
    );
  }
}

export default SelectCounty;
